"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const NodeSectionMapEvents_1 = __importDefault(require("./NodeSectionMapEvents"));
const NodeLayerMapEvents_1 = __importDefault(require("./NodeLayerMapEvents"));
const RoutingSectionMapEvents_1 = __importDefault(require("./RoutingSectionMapEvents"));
const RoutingLayerMapEvents_1 = __importDefault(require("./RoutingLayerMapEvents"));
const PathLayerMapEvents_1 = __importDefault(require("./PathLayerMapEvents"));
const PathSectionMapEvents_1 = __importDefault(require("./PathSectionMapEvents"));
const ScenarioSectionMapEvents_1 = __importDefault(require("./ScenarioSectionMapEvents"));
const AccessibilityMapSectionMapEvents_1 = __importDefault(require("./AccessibilityMapSectionMapEvents"));
const transitionEvents = [
    NodeSectionMapEvents_1.default,
    NodeLayerMapEvents_1.default,
    RoutingSectionMapEvents_1.default,
    RoutingLayerMapEvents_1.default,
    AccessibilityMapSectionMapEvents_1.default,
    PathLayerMapEvents_1.default,
    PathSectionMapEvents_1.default,
    ScenarioSectionMapEvents_1.default
];
const transitionEventsArr = transitionEvents.flatMap((ev) => ev);
exports.default = transitionEventsArr;
//# sourceMappingURL=index.js.map